interface CategoryFilterProps {
  selectedCategory: string;
  onSelectCategory: (category: string) => void;
}

export default function CategoryFilter({ selectedCategory, onSelectCategory }: CategoryFilterProps) {
  const categories = [
    { name: 'All', icon: 'ri-grid-line' },
    { name: 'Nutrition', icon: 'ri-apple-line' },
    { name: 'Fitness', icon: 'ri-heart-pulse-line' },
    { name: 'Mental Health', icon: 'ri-brain-line' },
    { name: 'Recipes', icon: 'ri-restaurant-line' }
  ];

  return (
    <section className="py-12 bg-gradient-to-b from-emerald-50 to-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex flex-wrap justify-center gap-3">
          {categories.map((category) => (
            <button
              key={category.name}
              onClick={() => onSelectCategory(category.name)}
              className={`flex items-center gap-2 px-5 py-2.5 rounded-full font-medium text-sm whitespace-nowrap transition-all cursor-pointer ${
                selectedCategory === category.name
                  ? 'bg-emerald-600 text-white shadow-md'
                  : 'bg-white text-gray-700 hover:bg-emerald-50 border border-gray-200'
              }`}
            >
              <i className={`${category.icon} text-base`}></i>
              {category.name}
            </button>
          ))}
        </div>
      </div>
    </section>
  );
}
